import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
import {AppProvider} from '@shopify/polaris';
import AuthGatekeeper from './components/auth-gatekeeper';
import './index.css';

ReactDOM.render(
	<AppProvider>
		<AuthGatekeeper>
			<App />
		</AuthGatekeeper>
	</AppProvider>,
	document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js